module.exports = __webpack_public_path__ + "../resources/images/drophint_2x-2a4576a6059d5a71fef497b8f22da982.png";